var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "owa-modal-frame",
    {
      attrs: {
        "is-showing": _vm.isShowing,
        "has-sections": false,
        title: "Use a Kit!",
        "component-class": "upsell",
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c("p", { staticClass: "line-length-xl margin-bottom-xl" }, [
        _c(
          "span",
          { staticClass: "size-lg" },
          [
            _c("font-awesome-icon", {
              staticClass: "margin-right-5xs",
              attrs: { icon: _vm.$v7.solid.faToolbox },
            }),
            _vm._v(
              "\n      The easiest way to use icons on your website is with a "
            ),
            _c("strong", [_vm._v("Kit")]),
            _vm._v(
              ". It’s a custom version of Font Awesome bundled with only the icons, tools,\n      and settings you need.\n    "
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "message margin-bottom-sm margin-top-md tablet:padding-x-2xl tablet:padding-y-xl laptop:padding-x-5xl laptop:padding-y-3xl",
          staticStyle: {
            "--message-background": "var(--fa-lt-gravy)",
            "--link-color": "var(--fa-dk-gravy)",
            "--link-hover-color": "var(--fa-blue)",
          },
        },
        [_c("start-form", { attrs: { "has-arrived-from-figma": false } })],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "flat link block text-right margin-top-md padding-bottom-0",
          attrs: { type: "button" },
          on: { click: _vm.handleDownloadClick },
        },
        [
          _vm._v(
            "\n    Never mind. Continue with downloading Font Awesome Free\n    "
          ),
          _c("font-awesome-icon", {
            attrs: { icon: _vm.$v7.solid.faArrowRight },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }